module.exports = __webpack_public_path__ + "img/15-small.6fff0305.jpg";